import { Button, Form } from 'react-bootstrap';

// Tiers pedidos por Jason 2026-09-19 (mesmo SET fechado que o backend
// aceita em `?per_page=`, ver painel-eimovel-node v1.12.0 `src/paginacao.js`
// — mandar um valor fora desse conjunto simplesmente cai no padrão de 100).
const TAMANHOS = [100, 250, 500, 1000];

// `meta` é o objeto que toda listagem paginada do backend já devolve
// (`{ total, page, per_page, last_page }`) — usado em Clientes e Leads
// por ora (Usuários/Empresas ficam sem isso, volume baixo o suficiente
// pra não precisar).
export default function Paginacao({ meta, aoMudarPagina, aoMudarPerPage }) {
  if (!meta || meta.total === 0) return null;
  const { page, last_page: ultimaPagina, total, per_page: perPage } = meta;

  return (
    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
      <div className="text-muted small">
        {total} no total — página {page} de {ultimaPagina}
      </div>
      <div className="d-flex align-items-center gap-2">
        <Form.Select
          size="sm"
          style={{ width: 'auto' }}
          value={perPage}
          onChange={(e) => aoMudarPerPage(Number(e.target.value))}
        >
          {TAMANHOS.map((tamanho) => (
            <option key={tamanho} value={tamanho}>
              {tamanho} por página
            </option>
          ))}
        </Form.Select>
        <Button
          size="sm"
          variant="outline-secondary"
          disabled={page <= 1}
          onClick={() => aoMudarPagina(page - 1)}
        >
          Anterior
        </Button>
        <Button
          size="sm"
          variant="outline-secondary"
          disabled={page >= ultimaPagina}
          onClick={() => aoMudarPagina(page + 1)}
        >
          Próxima
        </Button>
      </div>
    </div>
  );
}
